module.exports = __webpack_public_path__ + "static/media/memberBlackIcon.4a50b184.svg";